import { ApiResult, httpRequest, Urls } from './Shared';

const UNITMAP_INT_API_URL = `${Urls.BASE_URL}/Map`;

export interface MapUnitColorDto {
    id: number;
    hexColor: string;
    label: string;
}

export interface MapUnitDto {
    unitId: string;
    unitColor: MapUnitColorDto;
    unitColorId: number;
}

export interface MapStopDto {
    stopNumber: number;
    description: string;
    directions: string;
    floor: string;
    x: number;
    y: number;
    isAmenity: boolean;
}

export interface UnitMapConfiguration {
    stops: MapStopDto[];
    units: MapUnitDto[];
    unitMapId: string;
    isDeleted: boolean;
}

export const getUnitMapConfiguration = (propertySlug: string) =>
    httpRequest<UnitMapConfiguration>(`${UNITMAP_INT_API_URL}/${propertySlug}/configuration`);

export const getUnitMapConfigurationById = (propertyId: number) =>
    httpRequest<UnitMapConfiguration>(`${UNITMAP_INT_API_URL}/${propertyId}/configurationById`);

export const updateUnitMapConfiguration = (
    propertyId: number,
    configuration: UnitMapConfiguration | undefined
): Promise<ApiResult<UnitMapConfiguration>> => {
    return httpRequest<UnitMapConfiguration>(
        `${UNITMAP_INT_API_URL}/${propertyId}/configuration`,
        'post',
        configuration
    );
};

export const getAllUnitColors = (): Promise<ApiResult<MapUnitColorDto[]>> => {
    return httpRequest<MapUnitColorDto[]>(`${UNITMAP_INT_API_URL}/unitColors`, 'get');
};



// WEBPACK FOOTER //
// ./src/api/UnitMap.ts